import type { SVGProps } from "react";
export interface HairdryerIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HairdryerIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HairdryerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12.36 12.356a1.125 1.125 0 0 1 1.2.913l.014.114.366 4.357.01.338a3.12 3.12 0 0 1-2.058 2.855l.2.794a1.125 1.125 0 0 1-2.183.546l-.287-1.148h-.06a3.126 3.126 0 0 1-3.033-2.367L5.363 14.07l2.184-.543 1.166 4.686.047.14c.138.313.45.522.802.522h1.264a.876.876 0 0 0 .873-.946l-.367-4.358-.004-.114c.01-.57.45-1.052 1.031-1.1Zm-6.176.352a1.125 1.125 0 0 1 1.363.819l-2.184.543a1.125 1.125 0 0 1 .82-1.362ZM9.875 8a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m2.25 0a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0"
      />
      <path
        fill={color}
        d="M3.125 8A4.875 4.875 0 0 0 8 12.875c1.777 0 3.35-.315 5.36-.73 1.982-.408 4.322-.896 7.515-1.183V5.037c-3.193-.287-5.534-.774-7.515-1.183-2.01-.414-3.583-.729-5.36-.729A4.875 4.875 0 0 0 3.125 8m20 3.069a2.14 2.14 0 0 1-1.755 2.099l-.203.026c-3.102.274-5.36.744-7.353 1.155-1.984.409-3.774.776-5.814.776A7.125 7.125 0 0 1 8 .875c2.04 0 3.83.367 5.814.776 1.992.411 4.251.881 7.354 1.155a2.14 2.14 0 0 1 1.957 2.125z"
      />
    </svg>
  );
}
